const getProvetaUrl = (): string => {
  switch (globalThis.location.origin) {
    case 'https://proveplan.sample-dev.mattilsynet.io':
      return 'https://proveta.sample-dev.mattilsynet.io'
    case 'https://proveplan.sample-training.mattilsynet.io':
      return 'https://proveta.sample-training.mattilsynet.io'
    case 'https://proveplan.sample.mattilsynet.io':
      return 'https://proveta.sample.mattilsynet.io'
    default:
      return 'http://localhost:5173'
  }
}
const getApiUrl = (): string => {
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
    return `${globalThis.location.origin}/api`
  }
  switch (globalThis.location.origin) {
    case 'https://proveplan.sample-dev.mattilsynet.io':
      return 'https://sample.sample-dev.mattilsynet.io'
    case 'https://proveplan.sample-training.mattilsynet.io':
      return 'https://sample.sample-training.mattilsynet.io'
    case 'https://proveplan.sample.mattilsynet.io':
      return 'https://sample.sample.mattilsynet.io'
    default:
      return `${globalThis.location.origin}/api`
  }
}
export const BASE_URL = getApiUrl()
export const PROVETA_URL = getProvetaUrl()
